import React from 'react';
import Icon from '../openplay/OpenPlayIcon';

const PlaceImageModal = ({ isOpen, place, fallbackEventImage, placeImageIndex, setPlaceImageIndex, onClose }) => {
  if (!isOpen || !place) return null;

  const gallery = [place.coverImageUrl, ...(place.galleryUrls || [])].map((url) => String(url || '').trim()).filter(Boolean);
  const uniqueGallery = [...new Set(gallery)];
  const safeIndex = Math.min(placeImageIndex, Math.max(uniqueGallery.length - 1, 0));
  const activeImage = uniqueGallery[safeIndex] || fallbackEventImage;
  const handlePrev = () => setPlaceImageIndex((prev) => (prev <= 0 ? uniqueGallery.length - 1 : prev - 1));
  const handleNext = () => setPlaceImageIndex((prev) => (prev + 1) % uniqueGallery.length);

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 md:p-6">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-3xl bg-card rounded-2xl border border-border shadow-elevation-3 overflow-hidden">
        <div className="relative">
          <div className="flex items-center justify-between px-4 py-3 border-b border-border">
            <p className="text-sm font-semibold text-foreground">코트 이미지</p>
            <button type="button" className="text-sm text-muted-foreground hover:text-foreground" onClick={onClose}>
              닫기
            </button>
          </div>
          <div className="relative bg-black">
            <img src={activeImage} alt="place" className="w-full max-h-[70vh] object-contain" />
            {uniqueGallery.length > 1 && (
              <>
                <button
                  type="button"
                  onClick={handlePrev}
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/60 text-white flex items-center justify-center"
                  aria-label="이전 이미지"
                >
                  <Icon name="ChevronLeftIcon" size={20} />
                </button>
                <button
                  type="button"
                  onClick={handleNext}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/60 text-white flex items-center justify-center"
                  aria-label="다음 이미지"
                >
                  <Icon name="ChevronRightIcon" size={20} />
                </button>
              </>
            )}
          </div>
          <div className="px-4 py-3 text-xs text-muted-foreground">
            {uniqueGallery.length > 0 ? `${safeIndex + 1} / ${uniqueGallery.length}` : '이미지가 없습니다.'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceImageModal;
